export const LoaderLogo: React.FC<{ isLoading?: boolean }> = ({}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "#ffffff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          padding: "4px 9px 4px 9px",
          borderRadius: "8px",
          height: "35px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(90deg, #2c3135, #555, #2c3135)",
          backgroundSize: "300% 100%",
          animation: "logoGradient 2.5s ease-in-out infinite",
          boxShadow: "0 0 30px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div
          style={{
            color: "#ffffff",
            font: "700 20px Manrope",
          }}
        >
          HMREP
        </div>
      </div>
      <style>
        {`
            @keyframes logoGradient {
              0% { background-position: 0% 50%; }
              50% { background-position: 100% 50%; }
              100% { background-position: 0% 50%; }
            }
          `}
      </style>
    </div>
  );
};
